import { useState } from 'react';
import menu from './../../assets/icons/menu.svg';
import style from './header.module.css';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  document.querySelectorAll('a').forEach((a) => {
    a.addEventListener('click', () => {
      setIsOpen(false);
    });
  });

  return (
    <header className={style.header}>
      <p>Alex Chun</p>
      <nav className={isOpen ? style.show : ''}>
        <a href="#about">About Me</a>
        <a href="#skills">Skills</a>
        <a href="#portfolio">Portfolio</a>
        <a href="#contact">Contact</a>
        <a href="/documents/resume.pdf" download>
          Resume
        </a>
      </nav>
      <button className={style.button} onClick={toggleMenu}>
        <img src={menu} alt="" />
      </button>
    </header>
  );
}
